import request from '@/ajax'
import store from '@/store';
import { getDeviceType } from '@/utils';
import { navigateUrl } from '@/utils/index'
import { yunUrl } from '@/ajax/index.js'
import Vue from 'vue'
import { CLOUD_GROUP_CONTROL_DEVICES, CLOUD_QUN_CONTROL } from '@/utils/key.js'

function getCloudUserStorageKey(key) {
  const info = JSON.parse(localStorage.getItem('info') || '{}')
  return `${key}_${info.customer_id || 'guest'}`
}
export function $postMessage(data){
  uni.postMessage({
    data
  })
}
export function $openDownApp() {
  store.commit('popup/setPagePopupData', { showDownActivity: true })
}

export function $isLeyou() {
  return false
}
export function $isApp() {
  return store.state.isApp
}
export function $loginPopup(flag = true) {
  store.commit('popup/setloginpop', flag)
}

export function $isSdk() {
  if (location.href.includes('sdkpage')) {
    return true
  } else {
    return false
  }
}

export function $isLogin(flag) {
  if(!store.getters.logged){
    if(!flag) store.commit('popup/setloginpop', true)
    return false
  }else {
    return true
  }
}

export function $copy(text) {
  let input = document.createElement('input')
  input.value = text
  document.body.appendChild(input)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    Vue.prototype.$toast("复制成功")
  }
  document.body.removeChild(input)
}

export function $device() {
  const data = getDeviceType();
  return data;
}
export function $getYunIcon(type) {
  return require(`@/assets/image/device/${type}.png`)
}
export function $openYunDevice(supplierId, instanceCode, kzdata = {}) {
  const getStorageValue = (key, defaultValue) => {
    const value = localStorage.getItem(key)
    return value !== null ? value : defaultValue
  }

  return request('/yun/yunConfig').then((rs) => {
    if (rs.code != 200) {
      this.$toast(rs.msg)
      return
    }

    const params = new URLSearchParams({
      userCode: rs.data.code,
      appKey: rs.data.appKey,
      appSecret: rs.data.appSecret,
      desKey: rs.data.desKey,
      supplierId,
      instanceCode,
      soundStatus: getStorageValue('soundStatus', 1),
      micStatus: getStorageValue('micStatus', 1),
      cameraStatus: getStorageValue('cameraStatus', 1),
      inputStatus: getStorageValue('keyBord', 0),
      sensorStatus: getStorageValue('sensorStatus', 0),
    })
    const groupControl = JSON.parse(localStorage.getItem(getCloudUserStorageKey(CLOUD_GROUP_CONTROL_DEVICES)) || '{"masterCode":"","controlledCodes":""}')
    if (localStorage.getItem(getCloudUserStorageKey(CLOUD_QUN_CONTROL)) === 'true' && groupControl.masterCode) {
      params.set('masterCode', groupControl.masterCode)
      params.set('controlledCodes', groupControl.controlledCodes)
    }
      // fullScreenStatus: getStorageValue('fullScreenStatus', 0),
    const route = {
      path: '/pages/yun/device/yun-iframe',
      query: { src: `${yunUrl}?${params.toString()}` }
    };
    if (kzdata.linkType === 'replace') {
      this.$router.replace(route);
    } else {
      this.$router.push(route);
    }
  })
}
export function $getTopicNumber(number) {
  //   1万以内：展示实际数量
  // 1万以上：N 万 ，如5400，展示5万
  if (!number) return ''
  if (number < 10000) {
    return number
  } else {
    return Math.floor(number / 10000) + '万'
  }
}

export function $formatPostTime(postTime) {
  postTime = postTime.replace(/-/g, '/');
  const now = new Date();
  const postDate = new Date(postTime);
  const diff = now - postDate; // 计算时间差（毫秒）

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = now.getFullYear() - postDate.getFullYear();
  if (minutes < 1) {
    return '刚刚';
  } else if (minutes < 60) {
    return `${minutes}分钟前`;
  } else if (hours < 24) {
    return `${hours}小时前`;
  } else if (years === 0) {
    return `${postDate.getMonth() + 1}-${postDate.getDate() < 10 ? '0' + postDate.getDate() : postDate.getDate()}`;
  } else {
    return `${postDate.getFullYear()}-${(postDate.getMonth() + 1) < 10 ? '0' + (postDate.getMonth() + 1) : postDate.getMonth() + 1}-${postDate.getDate() < 10 ? '0' + postDate.getDate() : postDate.getDate()}`;
  }
}
export function getTimeSince(dateString) {
  // 将传入的日期字符串转换为Date对象  解决ios 时间转换问题
  let date = new Date(dateString.replace(/-/g, '/'));
  // 获取当前时间  
  let now = new Date();
  // 计算两个日期之间的毫秒差  
  let diff = date - now;
  // 将毫秒差转换为时分秒格式  
  let timeSince = {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60))),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60)
  };
  return timeSince;
}
export function $getTimeSince(time) {
  let obj = getTimeSince(time)
  if (obj.days > 0) {
    let hours = obj.hours - obj.days * 24
    return obj.days + '天' + hours + '小时' + obj.minutes + '分钟'
  } else if (obj.hours > 0) {
    return obj.hours + '小时' + obj.minutes + '分钟'
  } else if (obj.minutes > 0) {
    return obj.minutes + '分钟'
  }

}

const plugins = {
  install(Vue, options = {}) {
    Object.assign(Vue.prototype, {
      $ajax: request,
      $device,
      $getTopicNumber,
      $formatPostTime,
      $isLogin,
      $getYunIcon,
      $openYunDevice,
      $getTimeSince,
      $navigateUrl: navigateUrl,
      $copy,
      $isSdk,
      $loginPopup,
      $isLeyou,
      $isApp,
      $postMessage,
      $openDownApp,
      $c: {
        toast: (msg) => {
          Vue.prototype.$toast(msg)
        }
      }
    })
  }
}

export default plugins
